import { Route, RouteProps, Routes, BrowserRouter } from 'react-router-dom';
import { Home, ReviewDetail } from './views';
import { QueueTypes } from './components/ReviewsTable/WorkQueue.utils';
import { Roles } from '@reviews/interfaces';

export enum AppRoutes {
    HOME = '/home',
    REVIEW_DETAIL = '/review/:id',
    NEW = '/new',
    PENDING = '/pending',
    RESPONSE_REQUIRED = '/response_required',
    SEARCH = '/search',
    SEARCH_WITH_PARAMS = '/search/?criteria=:criteria&value=:value',
    BULK_REVIEWS = '/bulk_reviews',
    TEAM = '/team',
    EXTERNAL_SYNC = '/external-sync',
    GUEST_CONTENT_REVALIDATE = '/guest-content-revalidate',
    UNIT_SYNC = '/unit-sync',
    REVIEW_SUMMARIES = '/review-summaries',
    PROPERTY_MANAGER_CONFIG = '/property-manager-config',
}

export const queueTypeToAppRoute = (role?: Roles) => {
    return {
        [QueueTypes.NEW]: { index: 0, path: AppRoutes.NEW },
        [QueueTypes.MINE]: { index: 1, path: AppRoutes.PENDING },
        [QueueTypes.RESPONSE_REQUIRED]: { index: 2, path: AppRoutes.RESPONSE_REQUIRED },
        [QueueTypes.SEARCH]: { index: role === Roles.EMPLOYEE ? 0 : 3, path: AppRoutes.SEARCH },
        [QueueTypes.BULK_IMPORT]: { index: 4, path: AppRoutes.BULK_REVIEWS },
        // Util parent tab (admin): External is the default sub-tab.
        [QueueTypes.EXTERNAL_SYNC]: { index: 5, path: AppRoutes.EXTERNAL_SYNC },
        [QueueTypes.GUEST_CONTENT_REVALIDATE]: { index: 5, path: AppRoutes.GUEST_CONTENT_REVALIDATE },
        [QueueTypes.UNIT_SYNC]: { index: 5, path: AppRoutes.UNIT_SYNC },
        [QueueTypes.REVIEW_SUMMARIES]: { index: 5, path: AppRoutes.REVIEW_SUMMARIES },
        [QueueTypes.MY_TEAM]: { index: 6, path: AppRoutes.TEAM },
        [QueueTypes.PROPERTY_MANAGER_CONFIG]: { index: 7, path: AppRoutes.PROPERTY_MANAGER_CONFIG },
    };
};

const routes: RouteProps[] = [
    { path: AppRoutes.HOME, element: <Home /> },
    { path: AppRoutes.REVIEW_DETAIL, element: <ReviewDetail /> },
    { path: AppRoutes.NEW, element: <Home queueType={QueueTypes.NEW} /> },
    { path: AppRoutes.PENDING, element: <Home queueType={QueueTypes.MINE} /> },
    { path: AppRoutes.RESPONSE_REQUIRED, element: <Home queueType={QueueTypes.RESPONSE_REQUIRED} /> },
    { path: AppRoutes.SEARCH || AppRoutes.SEARCH_WITH_PARAMS, element: <Home queueType={QueueTypes.SEARCH} /> },
    { path: AppRoutes.BULK_REVIEWS, element: <Home queueType={QueueTypes.BULK_IMPORT} /> },
    { path: AppRoutes.EXTERNAL_SYNC, element: <Home queueType={QueueTypes.EXTERNAL_SYNC} /> },
    { path: AppRoutes.GUEST_CONTENT_REVALIDATE, element: <Home queueType={QueueTypes.GUEST_CONTENT_REVALIDATE} /> },
    { path: AppRoutes.UNIT_SYNC, element: <Home queueType={QueueTypes.UNIT_SYNC} /> },
    { path: AppRoutes.REVIEW_SUMMARIES, element: <Home queueType={QueueTypes.REVIEW_SUMMARIES} /> },
    { path: AppRoutes.PROPERTY_MANAGER_CONFIG, element: <Home queueType={QueueTypes.PROPERTY_MANAGER_CONFIG} /> },
    { path: AppRoutes.TEAM, element: <Home queueType={QueueTypes.MY_TEAM} /> },
    { path: '*', element: <Home /> },
];

export const Router = () => (
    <BrowserRouter>
        <Routes>
            {routes.map((route, i) => (
                <Route key={i} {...route} />
            ))}
        </Routes>
    </BrowserRouter>
);
